import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpErrorResponse,
    HttpResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    private isShowing = false;

    constructor(private router: Router) { }

    showAlert() {
        Swal.fire({
            icon: 'warning',
            title: 'Session Expired',
            text: 'Your session has expired. Please login again.',
            confirmButtonText: 'Back to Login',
            allowOutsideClick: false,
            allowEscapeKey: false
        }).then(() => {

            sessionStorage.clear();
            localStorage.clear();

            this.isShowing = false;
            this.router.navigate(['/']);
        });
    }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(request).pipe(
            tap((event: HttpEvent<any>) => {

                if (event instanceof HttpResponse) {
                    if (event.status === 401 && !this.isShowing) {

                        this.isShowing = true;
                        this.showAlert();
                       
                    }
                }

            }),
            catchError((error: HttpErrorResponse) => {

                if (error.status === 401 && !this.isShowing) {

                    this.isShowing = true;

                    this.showAlert();
                }

                return throwError(() => error);
            })
        );
    }
}
